'use client'

export { Label1 } from './Label1'
export { Label2 } from './Label2'
export { Label3 } from './Label3'
export { Label4 } from './Label4'
